import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-tab',
  templateUrl: './tab.component.html',
  styleUrls: ['./tab.component.scss']
})
export class TabComponent {
  @Input() tabs: any[] = [];
  @Input() tabStyle: string = 'default';
  activeTab: number = 0;

  activateTab(index: number) {
    this.activeTab = index;
  }
}


